module.exports = __webpack_public_path__ + "static/img/manual_ja_3.8ddd541.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_3.png
// module id = LhoC
// module chunks = 4